import jQuery from 'jquery';
window.jQuery = jQuery;
window.$ = jQuery;

(function ($) {
  $.fn.ev = function (event, handler) {
    this.each(function () {
      var $this = $(this);

      $this.off(event).on(event, handler);
    });

    return this;
  };

  $.fn.evAdd = function (event, handler) {
    this.each(function () {
      var $this = $(this);

      $this.on(event, handler);
    });

    return this;
  };

  $.fn.evRemove = function (event, handler) {
    this.each(function () {
      var $this = $(this);

      $this.off(event);
    });

    return this;
  };

})(jQuery);

import moment from 'moment';
window.moment = moment;

// Import Vue
import Vue from 'vue';

// Import Framework7
import Framework7 from 'framework7/framework7-lite.esm.bundle.js';

// Import Framework7-Vue Plugin
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js';

// Import Framework7 Styles
import 'framework7/css/framework7.bundle.css';

// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/app.scss';

// Import App Component
import App from '../components/app.vue';

import store from './store.js'

// Init Framework7-Vue Plugin
Framework7.use(Framework7Vue);

// Init App
new Vue({
  el: '#app',
  render: (h) => h(App),

  store: store,
  // Register App Component
  components: {
    app: App
  },
 
});